export default __webpack_public_path__ + "ad7a3f90872a7252a0573ce79910c8fa.png";